import react, { useState, useEffect } from "react";
import { Values } from "Interfaces/IParameters";
import {
  Section,
  Row,
  Flex,
  SelectedOption,
  Separator,
  SectionSelectedOptions,
  Option,
  FlexOption,
} from "./styled.component";
import CloseIcon from "@mui/icons-material/Close";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { useSelector } from "react-redux";

interface PropMultiple {
  title: string;
  options: Array<Values>;
  onChange: ({
    checked,
    value,
    label,
  }: {
    checked: boolean;
    value: string;
    label: string;
  }) => void;
  selected: Array<Values>;
  setIndexActive: (_p: number) => void;
  indexActive: number | null;
  currentIndex: number;
}

const MultiSelect = ({
  title,
  options,
  onChange,
  selected,
  setIndexActive,
  indexActive,
  currentIndex,
}: PropMultiple) => {
  const [openSection, setOpenSection] = useState<boolean>(false);
  const [localFiltrel, setLocalFilter] = useState<string>("");
  const { filterThema } = useSelector((state: any) => state.theme);

  useEffect(() => {
    if (indexActive !== null) {
      if (indexActive !== currentIndex) setOpenSection(false);
    }
  }, [indexActive, currentIndex]);

  useEffect(() => {
    if (openSection) setIndexActive(currentIndex);
  }, [openSection]);

  return (
    <Section>
      <Row>
        <Flex flex={7}>
          <input
            type="text"
            onClick={() => {
              setOpenSection(!openSection);
            }}
            onChange={({ target }) => {
              setLocalFilter(target.value);
            }}
          />
        </Flex>
        <Flex flex={3}>
          <input
            type="checkbox"
            onClick={({ target }) => {
              if (selected.length > 0 && selected.length === options.length) return null; 
              onChange({
                checked: true,
                label: "todos",
                value: "All",
              });
            }}
            checked={
              selected.length === options.length
                ? true
                : false
            }
          />
          <span
            style={{
              display: "flex",
              alignSelf: "flex-end",
              fontSize: 21,
              marginRight: 10,
            }}
          >
            Todos
          </span>
        </Flex>
      </Row>
      {selected.length > 0 && (
        <Row>
          <FlexOption flex={9}>
            <div style={{ display: "flex", border: 6 }}>
              {selected.map((select, index) => (
                <SelectedOption
                  key={index}
                  bgColor={filterThema?.bgColor || null}
                  textColor={filterThema?.textColor || null}
                >
                  {select.label.substring(
                    0,
                    select.label.length > 9 ? 9 : select.label.length
                  )}
                  <div
                    onClick={() => {
                      onChange({
                        checked: false,
                        label: select.label,
                        value: select.value,
                      });
                    }}
                  >
                    <CloseIcon
                      fontSize="small"
                      style={{ height: 18, cursor: "pointer", width: 14 }}
                    />
                  </div>
                </SelectedOption>
              ))}
            </div>
          </FlexOption>
          <Flex
            flex={1}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: 5,
                cursor: "pointer",
                width: 25,
                height: 25,
                marginLeft: 10,
              }}
              onClick={() => {
                onChange({
                  checked: false,
                  label: "todos",
                  value: "All",
                });
              }}
            >
              <DeleteSweepIcon />
            </div>
          </Flex>
        </Row>
      )}
      {/* <Separator/> */}
      {openSection && (
        <SectionSelectedOptions>
          <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "column",
              width: "100%",
            }}
          >
            {options.length > 0 ? (
              localFiltrel !== "" ? (
                options
                  .filter((op) =>
                    op.label.toLowerCase().includes(localFiltrel.toLowerCase())
                  )
                  .map((item) => {
                    if (selected.length > 0) {
                      let findOption = selected.find(
                        (select) => select.value === item.value
                      );
                      if (!findOption) {
                        return (
                          <Option
                            value={item.value}
                            onClick={() => {
                              onChange({
                                checked: true,
                                label: item.label,
                                value: item.value,
                              });
                            }}
                            bgColor={filterThema?.bgColor || null}
                            textColor={filterThema?.textColor || null}
                          >
                            {item.label}
                          </Option>
                        );
                      }
                    } else {
                      return (
                        <Option
                          value={item.value}
                          onClick={() => {
                            onChange({
                              checked: true,
                              label: item.label,
                              value: item.value,
                            });
                          }}
                          bgColor={filterThema?.bgColor || null}
                          textColor={filterThema?.textColor || null}
                        >
                          {item.label}
                        </Option>
                      );
                    }
                  })
              ) : (
                options.map((item) => {
                  if (selected.length > 0) {
                    let findOption = selected.find(
                      (select) => select.value === item.value
                    );
                    if (!findOption) {
                      return (
                        <Option
                          value={item.value}
                          onClick={() => {
                            onChange({
                              checked: true,
                              label: item.label,
                              value: item.value,
                            });
                          }}
                          bgColor={filterThema?.bgColor || null}
                          textColor={filterThema?.textColor || null}
                        >
                          {item.label}
                        </Option>
                      );
                    }
                  } else {
                    return (
                      <Option
                        value={item.value}
                        onClick={() => {
                          onChange({
                            checked: true,
                            label: item.label,
                            value: item.value,
                          });
                        }}
                        bgColor={filterThema?.bgColor || null}
                        textColor={filterThema?.textColor || null}
                      >
                        {item.label}
                      </Option>
                    );
                  }
                })
              )
            ) : (
              <span>No hay opciones</span>
            )}
          </div>
        </SectionSelectedOptions>
      )}
    </Section>
  );
};

export default MultiSelect;
